export function addPrefix(prefix, value) {
  return value.startsWith(prefix) ? value : prefix + value;
}
export function removePrefix(prefix, value) {
  return value.startsWith(prefix) ? value.slice(prefix.length, value.length) : value;
}
export function addSign(formatString) {
  return addPrefix('+', formatString);
}